import axios from 'axios'
import sendCaptcha from './sendCaptcha'
import getNewToken from './getNewToken'
import { readVerificationToken } from './lib'
import constants from './constants'

const postRequestHandler = async ({
  endpoint,
  postData,
  successCallback,
  errorCallback,
  captchaAction,
  headers,
  refreshTokenHandler,
}) => {
  if (!endpoint || typeof endpoint !== 'string') {
    console.warn('endpoint is empty or invalid')
    return
  }
  if (!postData || typeof postData !== 'object') {
    console.warn('postData is empty or invalid')
    return
  }
  if (!successCallback || typeof successCallback !== 'function') {
    console.warn('successCallback is empty or invalid')
    return
  }
  if (!errorCallback || typeof errorCallback !== 'function') {
    console.warn('errorCallback is empty or invalid')
    return
  }
  let token
  const interval = setInterval(() => {
    if (window.isCaptchaReady) {
      clearInterval(interval)

      if (constants.captchaIsEnterprise) {
        window.grecaptcha.enterprise.ready(async () => {
          token = await sendCaptcha(captchaAction)
          await handleRecaptchaTokenAndPost({
            token,
            postData,
            refreshTokenHandler,
            headers,
            successCallback,
            errorCallback,
            endpoint,
          })
        })
      } else {
        window.grecaptcha.ready(async () => {
          token = await sendCaptcha(captchaAction)
          await handleRecaptchaTokenAndPost({
            token,
            postData,
            refreshTokenHandler,
            headers,
            successCallback,
            errorCallback,
            endpoint,
          })
        })
      }
    }
  }, 100)
}

const handleRecaptchaTokenAndPost = async (data) => {
  const {
    token,
    postData,
    refreshTokenHandler,
    headers,
    successCallback,
    errorCallback,
    endpoint,
  } = data

  const finalHeaders = {
    'Content-Type': 'application/json',
    'x-language': document.documentElement.lang,
    ...headers,
  }
  if (refreshTokenHandler) {
    await getNewToken(refreshTokenHandler)
  }
  if (refreshTokenHandler) {
    finalHeaders['X-XSRF-TOKEN'] = readVerificationToken()
  }
  if (token) {
    try {
      const response = await axios.post(
        endpoint,
        {
          ...postData,
          recaptchaResponse: token,
        },
        {
          headers: finalHeaders,
        }
      )
    
      const { hasError, errorMessages, data } = response.data
      // response has error
      if (hasError) {
        errorCallback(errorMessages)
      } else if (data) {
        successCallback(response.data)
      } else {
        errorCallback()
      }
    } catch (e) {
      console.log(e)
      errorCallback()
    }
  } else {
    errorCallback()
  }
}

export default postRequestHandler
